import { useCallback } from 'react'
import useQueryParams from '../../../hooks/useQueryParams'

const QUERY_PARAMS_SCHEMA = { page: Number, perPage: Number, showInactive: Boolean }

export default function useFilters(initialValues = {}) {
  // eslint-disable-next-line no-unused-vars
  const [conditions, setConditions] = useQueryParams({
    initialValues,
    schema: QUERY_PARAMS_SCHEMA,
  })

  const handleFilterChange = useCallback(
    args => {
      setConditions({
        ...conditions,
        ...(args.month !== undefined && { checkDate: args.month }),
        query: args.query,
        page: 1,
        officeLocationId: args.officeLocationId,
        medicalProviderId: args.medicalProviderId,
        showInactive: args.showInactive || undefined,
      })
    },
    [conditions, setConditions],
  )

  const handlePageChange = useCallback(
    page => setConditions({ ...conditions, page }),
    [conditions, setConditions],
  )

  return {
    conditions,
    setConditions,
    handlePageChange,
    handleFilterChange,
  }
}
